export {Faq as Page};

import {Helmet} from "react-helmet-async";
import messages from "../../messages/messages.js";
import {useState} from "preact/hooks";
import {ChevronDownIcon, ChevronUpIcon} from "@heroicons/react/24/solid";
import {getSiteFaq} from "../../tenant/tenant-context.js";

function Faq() {
    const faqs = getSiteFaq();
    const [openIndex, setOpenIndex] = useState(null);

    const toggleAnswer = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="text-white">

            <Helmet>
                <title>{messages["SITE.NAME"]} | Frequently asked questions</title>
                <meta name="description" content={`The ${messages["SITE.NAME"]} Frequently asked questions`}/>
            </Helmet>

            <div className="sm:max-w-4xl">
                <h1>Frequently Asked Questions (FAQ)</h1>
                {faqs.map((item, index) => (
                    <>
                        {index > 0 && faqs[index - 1].section !== item.section && (
                            <h2 className="text-2xl mt-8 mb-4">{item.section}</h2>
                        )}
                        <div key={index} className="faq-item border-b py-3 border-gray-500">
                            <button
                                type="button"
                                className="faq-question flex w-full text-left text-lg md:text-1xl font-bold cursor-pointer"
                                aria-expanded={openIndex === index}
                                onClick={() => toggleAnswer(index)}
                            >
                                {item.question}
                                <span className="ml-auto" aria-hidden="true">
                                {openIndex === index ? <ChevronUpIcon className={"w-6 h-6"}/> :
                                    <ChevronDownIcon className={"w-6 h-6"}/>}
                            </span>
                            </button>
                            <div
                                className={`faq-answer pt-3 transition-all duration-300 ease-in-out ${openIndex === index ? 'block' : 'hidden'}`}
                                dangerouslySetInnerHTML={{__html: item.answer}}
                            />
                        </div>
                    </>
                ))}
                <div class="flex">
                    <a href="/get-in-touch" className="primary-btn mt-6 mx-auto">
                        Got more questions? Ask us!
                    </a>
                </div>
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        "mainEntity": faqs.map(item => ({
                            "@type": "Question",
                            "name": item.question,
                            "acceptedAnswer": {
                                "@type": "Answer",
                                "text": item.answer
                            }
                        }))
                    })}
                </script>
            </div>

        </section>
    );
}
